import React, { ReactNode } from 'react';

import { useProjects } from '../../Providers/ProjectsProvider';
import NoAccess from '../Views/NoAccess';

export type DealGPTContainerProps = {
  children: ReactNode;
};

const DealGPTContainer = ({ children }: DealGPTContainerProps): JSX.Element => {
  const { hasProjects, toggleArchiveChecked, isSearching, hasArchived } = useProjects();

  if (hasProjects || hasArchived || toggleArchiveChecked || isSearching) {
    return <>{children}</>;
  }
  return <NoAccess />;
};

export default DealGPTContainer;
